"use client";
import React from "react";
import styled from "styled-components";
import TestimonialCard from "./TestimonialCard";
import i18n from "@/i18n";
import { Trans } from "react-i18next";

const TestimonialContainer = styled.section`
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  max-width: 100%;
  width: 100%;
  padding: 90px 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  @media (max-width: 991px) {
    max-width: 100%;
    padding: 90px 20px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 85px 16px;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
`;

const SectionTitle = styled.h2`
  color: rgba(0, 189, 203, 1);
  font-size: 28px;
  font-family:
    IBM Plex Sans KR,
    -apple-system,
    Roboto,
    Helvetica,
    sans-serif;
  font-weight: 800;
  letter-spacing: -0.68px;
  align-self: center;
`;

const TestimonialGrid = styled.div`
  z-index: 10;
  display: flex;
  margin-top: 40px;
  align-items: center;
  color: rgba(255, 255, 255, 1);
  justify-content: center;
  flex-wrap: wrap;
  @media (max-width: 991px) {
    margin-top: 40px;
  }
`;

export default function TestimonialSection() {
  const testimonials = [
    {
      image: "https://front.videomonster.com/images-7cuytg20/common/newlanding2024/testimonial_2.png",
      title: <Trans i18nKey="web.pc.landing.2025.testimonial.a.title"><span /></Trans>,
      descriptions: [
        i18n.t("web.pc.landing.2025.testimonial.a.des.1"),
        i18n.t("web.pc.landing.2025.testimonial.a.des.2"),
      ],
      author: i18n.t("web.pc.landing.2025.testimonial.a.author"),
    },
    {
      image: "https://front.videomonster.com/images-7cuytg20/common/newlanding2024/testimonial_3.png",
      title: <Trans i18nKey="web.pc.landing.2025.testimonial.b.title"><span /></Trans>,
      descriptions: [
        i18n.t("web.pc.landing.2025.testimonial.b.des.1"),
        i18n.t("web.pc.landing.2025.testimonial.b.des.2"),
      ],
      author: i18n.t("web.pc.landing.2025.testimonial.b.author"),
    },
    {
      image: "https://front.videomonster.com/images-7cuytg20/common/newlanding2024/testimonial_1.png",
      title: <Trans i18nKey="web.pc.landing.2025.testimonial.c.title"><span /></Trans>,
      descriptions: [
        i18n.t("web.pc.landing.2025.testimonial.c.des.1"),
        i18n.t("web.pc.landing.2025.testimonial.c.des.2"),
      ],
      author: i18n.t("web.pc.landing.2025.testimonial.c.author"),
    },
  ];

  return (
    <TestimonialContainer>
      <ContentWrapper>
        <SectionTitle>{i18n.t("web.pc.landing.2025.testimonial.title")}</SectionTitle>
        <TestimonialGrid>
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} {...testimonial} />
          ))}
        </TestimonialGrid>
      </ContentWrapper>
    </TestimonialContainer>
  );
}
